// import { JobProfileTableStyle } from "./JobProfileTableStyle"

import { JobProfileTableStyle } from "../job-profile-table/JobProfileTableStyle"

export const TABLE_COMPETENCIES_ITEMS = [
	{
		name: "category_name",
		label: "Categoría",
	},
	{
		name: "name",
		label: "Competencia",
	},
	{
		name: "interview_score",
		label: "Entrevista por competencia",
	},
	{
		name: "evaluation_score",
		label: "Evaluación por desempeño",
	},
]
export function JobProfileTableCompetencies({
	data,
	onDelete,
	onEdit,
	options,
	actions,
}) {
	return (
		<JobProfileTableStyle
			{...{
				items: TABLE_COMPETENCIES_ITEMS,
				data,
				onDelete,
				onEdit,
				options,
				actions,
			}}
		/>
	)
}
